// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bolt-card {
  border-radius: 4px;
  overflow: hidden;
  padding: 20px 0px;
}
@media screen and (min-width: 0\\0 ) {
  .bolt-card {
    border-radius: 0;
  }
}
@media (forced-colors: active) {
  .bolt-card {
    border: solid 1px;
  }
}
@media screen and (max-width: 599px) {
  .bolt-card {
    border-radius: 0;
  }
}

.bolt-card-with-header {
  padding-top: 0px;
}

.bolt-card-content {
  overflow: auto;
}

.bolt-card-footer {
  padding-top: 12px;
}

.bolt-card-no-vertical-padding {
  padding-top: 0px;
  padding-bottom: 0px;
}

.bolt-card-white {
  background-color: rgba(255, 255, 255, 1);
  background-color: var(--callout-background-color,rgba(255, 255, 255, 1));
}

.bolt-table-card {
  padding-bottom: 0px;
  padding-top: 0px;
}
.bolt-table-card .bolt-card-header {
  padding-bottom: 0px;
}
.bolt-table-card.no-column-headers .bolt-card-header {
  padding-bottom: 20px;
  border-bottom:  1px solid;
  border-bottom-color: rgba( 234, 234, 234 ,  1 );
  border-bottom-color: rgba( var(--palette-neutral-8,234, 234, 234) ,  1 );
}
.bolt-table-card .bolt-card-content {
  padding: 0px;
}
.bolt-table-card .bolt-header-commandbar {
  flex: auto;
  overflow: auto;
}

.bolt-button.bolt-card-expand-button {
  margin-left: 12px;
  margin-top: 16px;
  margin-right: 4px;
}

.bolt-card-header-collapsible {
  padding-left: 8px;
}

.bolt-card-expandable-header.bolt-card-expandable-header {
  padding-left: 8px;
}

.bolt-card-header-collapsed.bolt-card-header-collapsed {
  padding-bottom: 0px;
}

/*# sourceMappingURL=Card.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Components/Card/Card.scss","webpack://./../azure-devops-ui/bin/Components/Card/Card.css","webpack://./../azure-devops-ui/src/_coreStyles.scss","webpack://./../azure-devops-ui/src/Core/_platformCommon.scss"],"names":[],"mappings":"AAIA;EACI,kBAAA;EACA,gBAAA;EACA,iBAAA;ACHJ;ACqGI;EFrGJ;IAOQ,gBAAA;ECHN;AACF;ACsCI;EF3CJ;IAWQ,iBAAA;ECFN;AACF;AEsVI;EHhWJ;IAeQ,gBAAA;ECDN;AACF;;ADQA;EACI,gBAAA;ACLJ;;ADQA;EACI,cAAA;ACLJ;;ADQA;EACI,iBGyRS;AF9Rb;;ADQA;EACI,gBAAA;EACA,mBAAA;ACLJ;;ADQA;EACI,wCGgJqB;EFrJvB,wEAAwE;AAC1E;;AAEA;EDWI,mBAAA;ECTF,gBAAgB;ADWd;ACTJ;EACE,mBAAmB;ADYjB;ACVJ;EDYQ,oBAAA;ECVN,yBAAyB;EDavB,+CAAA;EACI,wEAAA;ACXR;ADcI;EACI,YAAA;ACZR;AACA;EACE,UAAU;EDeZ,cAAA;ACbA;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EDelB,iBAAA;ACbA;;AAEA;EDeA,iBAAA;ACbA;;AAEA;EDeA,iBAAA;ACbA;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mCAAmC","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
